module.exports = __webpack_public_path__ + "c35a-back.png";